import Icon from '../components/Icon.vue'

Icon.register({
  'sliders-h': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 384c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-336v16c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-16h-80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h80v-16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v16h336zM496 224c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-80v16c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-16h-336c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h336v-16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v16h80zM496 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-208v16c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-16h-208c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h208v-16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v16h208z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sliders-h.js
// module id = 1904
// module chunks = 0